// extracted by mini-css-extract-plugin
export default {"FooterSection":"lasFU_EUhEJSKfZbQuF5"};